import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthSharedService {
  private AuthInProgressSubject = new BehaviorSubject<boolean>(false);
  AuthInProgress = this.AuthInProgressSubject.asObservable();

  setAuthInProgress(value: boolean) {
    this.AuthInProgressSubject.next(value);
  }
}
